<template style="">
  <div class="Training">
    <div class="Training_top">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="游戏名称">
          <el-input type="text" v-model="formInline.user" placeholder="游戏名称"></el-input>
        </el-form-item>
        <el-form-item label="游戏分类">
          <el-select v-model="formInline.region" placeholder="游戏分类">
            <el-option v-for="item in GameData" :label="item.tit" :value="item.tit"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-collapse style="margin-left: 10px;" accordion v-model="activeNames" @change="handleChange">
      <el-collapse-item v-for="(item,i) in GameData" :title="item.tit" :name="i">
        <table border="0px">
          <tr>
            <td>序号</td>
            <td>任务名称</td>
            <td>任务描述</td>
            <td>操作</td>
          </tr>
          <tr v-for="(items,i) in item.shuju">
            <td style="width: 50px;">{{ i +1 }}</td>
            <td style="width: 120px;">{{ items.name }}</td>
            <td style="text-align: left;">{{ items.description }}</td>
            <td style="width: 80px;">
              <el-button type="primary" size="mini" @click="gourl(items.id)">开始训练</el-button>
            </td>
          </tr>
        </table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: '11111111',
      formInline: {
        user:"",
        region:""
      },
      activeNames:"1",
      GameData: [{
            tit: "思维力训练",
            shuju:[{
                name: 'Gonogo',
                description: 'GONOGO指导语：实验开始之后会随机出现‘△’或‘▽’，当出现符号‘▽’的时候请按鼠标左键，按任意键开始训练。每次训练，符号‘△’、‘▽’共呈现120次，每次呈现1秒。',
                id: '111'
              },{
                name: '爱荷华博弈任务',
                description: '您将看到ABCD四张牌（位置分别是左上、右上、左下、右下）显示在屏幕上，共150轮。每张牌背后都有相应的奖励和惩罚。通过按键选择一个牌，你将得到奖励或惩罚。选择后，屏幕上将显示两个值（例如）1000（此轮的分） 1250（你的总分）游戏从0分开始，您可以选择任何令牌，并且可以在任何时候切换令牌。目标是获得尽可能多的分数。注意：代币的奖赏和惩罚率是固定的。',
                id: '222'
              },{
                name: '快速计算',
                description: '屏幕会随机呈现加减法运算题，共10题。请尽快按屏幕上的数字键作答。',
                id: '333'
              },
            ]
          },{
            tit: "注意力训练",
            shuju: [{
                name: '	数字方格',
                description: '这是一个提高你注意力广度的训练。画面上会随机呈现一个数字方格，请按照自然数的顺序依次点击数字。如果正确，方格会变成绿色；如果错误，则变成灰色，请重新点击正确数字继续。明白指导语后请开始训练。',
                id: '111'
              },{
                name: '颜色速配',
                description: '	在规定时间内，给出4个由不同颜色、文字组成的图片，看字与图片的颜色是否匹配，将不匹配的图片挑选出来，然后进行下一组。',
                id: '222'
              },{
                name: '	阿拉伯数字划消',
                description: '这是一个提高你注意力稳定性的训练。画面上会呈现许多数字，请逐行检查每个数字，要求划掉指定数字（界面上方"刺激数"右侧的数字是需要划掉的）。如您选择正确，数字边框会变成绿色；选择错误，数字边框会变成灰色。如果划错可以再次点击取消。明白指导语后请开始训练。',
                id: '333'
              },{
                name: '数符转换',
                description: '按照参考表格的对应关系完全测试表格，可以使用小键盘或者鼠标操作。',
                id: '333'
              },
            ]
          },{
            tit: "记忆力训练",
            shuju: [{
                name: '记忆广度',
                description: '这是一个测试记忆广度的项目，点击开始测试后，屏幕会逐一显示一组一组的数字，你要努力记住这些数字，当这组数字显示结束后，需要你立即选择屏幕上的数字按钮，将这组数字重现出来。',
                id: '444'
              },{
                name: '短时记忆力',
                description: '这是一个提高你短时记忆力的训练。以下每一题中，画面会呈现一组字母（数字），一段时间后消失。随后呈现一些单个字母或数字，请判断它们是否在之前的字母组（数字组）中出现过，如果出现过请按【是】键，没有出现过按【否】键。明白指导语后请开始训练。',
                id: '555'
              },{
                name: '车牌记忆',
                description: '这是一个提高你记忆力的训练。以下每一题中，画面会呈现一个车牌，一段时间后车牌号消失。请在方框内写下完整的车牌号码。明白指导语后请开始训练。',
                id: '666'
              },{
                name: '图片记忆',
                description: '这是一个提高你记忆力的训练。以下每一题中，画面会呈现一组图片，呈现时间为1分钟，1分钟后图片的顺序会打乱。请点击图片，尽量将图片顺序恢复原状。明白指导语后请开始训练。',
                id: '777'
              },
            ]
          },{
            tit: "反应力训练",
            shuju: [{
                name: '视觉选择反应',
                description: '欢迎您参加本次实验，实验中您可能会在屏幕上看到红点或者绿点，当您看到红点请立即按f，看到绿点请立即按j。请将左手食指悬放在f键上方，右手食指悬放在j键上方。每一次结束后请立即准备下一次反应。抢答按错误记录。',
                id: '111'
              }, {
                name: '	视觉简单反应',
                description: '欢迎您参加本次实验，实验中您可能会在屏幕上看到红点，当您看到红点请立即按键做出反应。请将右手食指悬放在鼠标左键上方，每次结束后请立即准备下一次反应。抢答按错误记录。',
                id: '222'
              },{
                name: '	听觉选择反应',
                description: '欢迎您参加本次实验，实验中您可能会从耳机中听到高频和低频的“滴——”的声音，当您听到低频声音请立即按f，听到高频声音请立即按j。请将左手食指悬放在f键上方，右手食指悬放在j键上方。每一次结束后请立即准备下一次反应。抢答按错误记录。',
                id: '333'
              },{
                name: '听觉简单反应',
                description: '欢迎您参加本次实验，实验中您可能会从耳机中听到“滴——”的声音，当您听到声音，请立即按键做出反应。请将右手食指悬放在鼠标左键上方，每一次结束后请立即准备下一次反应。抢答按错误记录。',
                id: '333'
              },
            ]
          },{
            tit: "思维能力",
            shuju: [ {
                name: '	表象的心理旋转',
                description: '表象的心理旋转',
                id: '111'
              },]
        },{
          tit: "Ex+反应能力",
          shuju: [{
              name: '	Ex+反应能力',
              description: 'Ex+反应能力',
              id: 'Ex+反应能力'
            }]
        },{
          tit: "Ex+思维能力",
          shuju: [{
              name: 'Ex-句子-图形匹配',
              description: 'Ex-句子-图形匹配',
              id: 'Ex-句子-图形匹配'
            },{
              name: 'Ex-表象的心理旋转',
              description: 'Ex-表象的心理旋转',
              id: 'Ex-表象的心理旋转'
            },{
              name: 'Ex-选择作业实验',
              description: 'Ex-选择作业实验',
              id: 'Ex-选择作业实验'
            }, {
              name: 'Ex-河内塔问题',
              description: 'Ex-河内塔问题',
              id: 'Ex-河内塔问题'
            }]
        },{
          tit: "操控控制力任务",
          shuju: [{
              name: '轨道追踪',
              description: '轨道追踪',
              id: '轨道追踪'
            },{
              name: '听觉控制力',
              description: '听觉控制力',
              id: '听觉控制力'
            },{
              name: '视觉控制力',
              description: '视觉控制力',
              id: '视觉控制力'
            },{
              name: '操作控制力',
              description: '操作控制力',
              id: '操作控制力'
            },{
              name: '手眼协作力',
              description: '手眼协作力',
              id: '手眼协作力'
            }]
        },{
          tit:'认知训练',
          shuju:[{
            name:'认知训练',
            description:'认知训练',
            id:'认知训练'
          }]
        }],
    }
  },
  mounted() {

  },
  methods: {
    handleChange(val) {
      this.activeNames=val;
    },
    onSubmit() {
      console.log('submit!');
    },
    gourl(id) {
      if (id == 111) {
        this.$router.push('/training/Game_a_type');
      } else if (id == 333) {
        this.$router.push('/training/Game_alip_elimination');
      } else if (id == 444) {
        this.$router.push('/training/Game_memory_span');
      } else if (id == 555) {
        this.$router.push('/training/Game_short_memory');
      } else if (id == 'Ex+反应能力') {
        this.$router.push('/training/Game_reaction_rate');
      } else if (id == 'Ex-句子-图形匹配') {
        this.$router.push('/training/Game_pattern_matching');
      } else if (id == 'Ex-表象的心理旋转') {
        this.$router.push('/training/Game_mental_rotation');
      } else if (id == '视觉控制力') {
        this.$router.push('/training/Game_vision');
      }else if(id=='认知训练'){
        this.$router.push('/Game/TrainingIntro');
      }
    }
  },
}
</script>
<style>
  .Training{width: 100%;background-color: #fff;height: 100%;}
  .Training td{border: 1px solid #dadada;padding: 5px 15px;text-align: center;}
  .Training table{border-collapse: collapse;width: 99%;}
  .Training_top{height: 80px;}
  .Training_top form{margin-left: 20px;padding-top: 20px;}
</style>
